import './PageTitle.css'
export default function PageTitle({children}) {

  return(
    <h1 className="page-title">{ children }</h1>
  )
}